import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ballstonSpaConfig } from "./data";

export default function BallstonSpaPage() {
  return <CityPageTemplate config={ballstonSpaConfig} />;
}